import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "iconLess",
  "use": "iconLess-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"iconLess\"><g data-name=\"icon - less - 16px\" transform=\"translate(-1841 -966)\"><rect width=\"16\" height=\"16\" rx=\"8\" transform=\"translate(1841 966)\" fill=\"currentColor\" /><g data-name=\"↳color\"><path data-name=\"Line 153\" d=\"M1846 974h6\" stroke=\"#fff\" stroke-linecap=\"round\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol